<div class="d-flex flex-column justify-content-center align-items-center template">
  <div class="infographic">
    <i class="{{iconClass}} page-icons"></i>
  </div>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <h1 class="status">
      <ng-content select="[status]"></ng-content>
    </h1>
    <h2>
      <ng-content select="[title]"></ng-content>
    </h2>
    <p>
      <ng-content select="[description]"></ng-content>
    </p>
    <ng-content select="[button]"></ng-content>
  </div>
</div>
